import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf8a5d6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-panel__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-panel__header__groupName" }, "WPS 协作空间", -1))
const _hoisted_3 = { class: "group-panel__header__button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收起面板", -1))
const _hoisted_5 = {
  key: 0,
  class: "group-panel__userInfo"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "登录使用", -1))
const _hoisted_7 = { class: "group-panel__mainBox" }
const _hoisted_8 = {
  key: 0,
  class: "searchPanel"
}
const _hoisted_9 = { class: "group-panel__mainBox__input" }
const _hoisted_10 = { class: "group-panel__mainBox__groupInfo" }


const __default__ = {
  name: 'GroupPanel'
}

import { ref, watch } from 'vue'
import Icon from '@teams/common/components/icon'
import { OnClickOutside } from '@vueuse/components'
import useViewConfig from '@/hooks/useViewConfig'
import SearchGroup from '@teams/common/components/searchGroup/index.vue'
import UserInfoCard from '../userInfoCard/index.vue'
import GroupList from '../groupList/index.vue'
import GroupItem from '../groupList/groupItem.vue'
import SelectTemplate from '../selectTemplate/index.vue'
import { InputInst, NSpace } from 'naive-ui'
import { useUserStore } from '@/store/user'
import { ACCOUNT } from '@plus/env/dist/index.esm.js'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    closePanel: null
  },
  setup(__props: any) {

const props = __props as {
  closePanel?: () => void
}


const userStore = useUserStore()
const { currentAccountInfo } = useAccountChange()
const inputRef = ref<InputInst | null>(null)
const { shouldStickyGroupPanel, toggleStickyGroupPanel: toggleSticky } =
  useViewConfig()
const showSearchPanel = ref(false)
// 进入搜索面板
const openSearchPanel = () => {
  showSearchPanel.value = true
}
// 退出搜索面板
const closeSearchPanel = (e: MouseEvent) => {
  const elementClassName = (e.target as any).className
  const classNameList = [
    'group-panel__header__groupName',
    'group-panel__header',
    'userinfo'
  ]
  // 防止操作右键菜单时退出搜索面板
  if (classNameList.includes(elementClassName)) {
    closeSearch()
  }
}
// 退出搜索面板
const closeSearch = () => {
  showSearchPanel.value = false
}

const toggleStickyGroupPanel = () => {
  toggleSticky()
  props.closePanel?.()
}

const login = () => {
  location.href = `${ACCOUNT}?cb=${encodeURIComponent(location.href)}`
}
watch(
  () => currentAccountInfo.value,
  () => {
    // 当账号变更时，关闭抽屉的搜索态
    closeSearch()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock("div", {
    id: "group-panel",
    class: _normalizeClass(["group-panel", { 'group-panel--sticky': _unref(shouldStickyGroupPanel) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_n_tooltip, { trigger: "hover" }, {
          trigger: _withCtx(() => [
            _createVNode(_component_n_button, {
              tertiary: "",
              class: "team-btn",
              onClick: toggleStickyGroupPanel
            }, {
              default: _withCtx(() => [
                (!_unref(shouldStickyGroupPanel))
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      name: "fixed",
                      size: 16,
                      fill: "transparent"
                    }))
                  : (_openBlock(), _createBlock(_unref(Icon), {
                      key: 1,
                      name: "closeSpaceList",
                      size: 16,
                      fill: "transparent"
                    }))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(shouldStickyGroupPanel) ? '关闭面板' : '固定面板'), 1)
          ]),
          _: 1
        }),
        (!_unref(shouldStickyGroupPanel))
          ? (_openBlock(), _createBlock(_component_n_tooltip, {
              key: 0,
              trigger: "hover"
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_n_button, {
                  tertiary: "",
                  class: "team-btn",
                  onClick: __props.closePanel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Icon), {
                      name: "hideSpacePanel",
                      size: 16,
                      fill: "transparent"
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(userStore).currentAccount?.userid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(UserInfoCard)
        ]))
      : (_openBlock(), _createBlock(_unref(NSpace), {
          key: 1,
          class: "group-panel__login",
          align: "center",
          size: 12
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(Icon), {
                name: "avatar",
                size: 40,
                fill: "transparent"
              })
            ]),
            _createElementVNode("div", {
              class: "group-panel__login__text",
              onClick: login
            }, [
              _createVNode(_unref(NSpace), {
                size: 4,
                align: "center"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("div", null, [
                    _createVNode(_unref(Icon), {
                      name: "arrow-right",
                      size: 16,
                      fill: "transparent"
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_7, [
      (!showSearchPanel.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_n_input, {
                ref_key: "inputRef",
                ref: inputRef,
                placeholder: 
              _unref(userStore).currentAccount?.userid
                ? '搜索协作空间'
                : '登录后可搜索和新建空间'
            ,
                onFocus: openSearchPanel,
                class: "searchInput",
                disabled: !_unref(userStore).currentAccount?.userid
              }, {
                prefix: _withCtx(() => [
                  (_unref(userStore).currentAccount?.userid)
                    ? (_openBlock(), _createBlock(_unref(Icon), {
                        key: 0,
                        name: "search",
                        size: 16,
                        fill: "transparent"
                      }))
                    : (_openBlock(), _createBlock(_unref(Icon), {
                        key: 1,
                        name: "searchColorGray",
                        size: 16,
                        fill: "transparent"
                      }))
                ]),
                _: 1
              }, 8, ["placeholder", "disabled"]),
              _createVNode(SelectTemplate, {
                "is-login": !!_unref(userStore).currentAccount?.userid
              }, null, 8, ["is-login"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createBlock(GroupList, {
                key: _unref(userStore).currentAccount?.userid
              }))
            ])
          ]))
        : (_openBlock(), _createBlock(_unref(OnClickOutside), {
            key: 1,
            onTrigger: closeSearchPanel,
            class: "searchPanel"
          }, {
            default: _withCtx(() => [
              _createVNode(SearchGroup, { onCloseSearchPanel: closeSearch }, {
                groupItem: _withCtx((item) => [
                  _createVNode(GroupItem, {
                    id: item.id,
                    name: item.title,
                    groupName: item.groupName,
                    avatar: item.avatar,
                    isSelect: false,
                    "group-item-source-type": "latest",
                    "sticky-top": false,
                    auth: item.auth ? item.auth : 'guest',
                    spaceType: item.spaceType
                  }, null, 8, ["id", "name", "groupName", "avatar", "auth", "spaceType"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ])
  ], 2))
}
}

})